import { render, staticRenderFns } from "./IconDots3Horizontal.vue?vue&type=template&id=3538e6cd&"
import script from "./IconDots3Horizontal.vue?vue&type=script&lang=js&"
export * from "./IconDots3Horizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports